module.exports = __webpack_public_path__ + "img/gallery-nft-06.f1621a35.png";